import styled from 'styled-components';

import * as Yup from 'yup';

export const Email = styled.input`
    background: ${(props) => props.error && props.touched && 'var(--red50)'};
    border: ${(props) =>
        !props.touched ? '1px solid var(--gray200)' : props.error ? '1px solid var(--color-error-default)' : '1px solid var(--gray800)'};
    color: ${(props) => (props.disabled ? 'var(--gray700)' : 'var(--gray800)')};
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 16px;
    height: 20px;
    line-height: 24px;
    padding: 8px 12px;
`;

export const Text = styled.div`
    font-size: 14px;
    line-height: 16px;
    margin-top: 8px;

    &:disabled {
        color: var(--gray700);
    }
`;

export const ReportFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 16px 8px 16px;

    &&:nth-child(1) {
        margin-top: 16px;
    }

    @media (max-width: 1151px) {
        margin: 0;
        margin-bottom;

        &&:nth-child(2) {
            margin-top: 8px;
        }
    }
`;

export const Message = styled.textarea`
    background: ${(props) => props.error && props.touched && 'var(--red50)'};
    border: ${(props) =>
        !props.touched ? '1px solid var(--gray200)' : props.error ? '1px solid var(--color-error-default)' : '1px solid var(--gray800)'};
    color: var(--gray800);
    font-family: inherit;
    font-size: 16px;
    height: 76px;
    line-height: 24px;
    overflow-y: auto;
    padding: 8px 12px;
    resize: none;
`;
export const Label = styled.span`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.32px;
    line-height: 16px;
    margin-bottom: 8px;
`;

export const ReportSchema = Yup.object().shape({
    topic: Yup.string().required('Il campo è obbligatorio'),
    message: Yup.string().required('Il campo è obbligatorio'),
    email: Yup.string().email("L'email non è inserita correttamente").required('Il campo è obbligatorio'),
});

export const ErrorPlaceHolder = styled.div`
    min-height: 36px;
`;
